import { SpdrClientViewModel } from "../../../ViewModel/SpdrClientViewModel";
import { PdsrClientViewModel } from "../../../ViewModel/PdsrClientViewModel";

export function getIdOfSpdrOrPdsr(
  spdrOrPdsr: SpdrClientViewModel | PdsrClientViewModel | undefined
) {
  if (!spdrOrPdsr) {
    return -1;
  }

  let spdrOrPdsrId = -1;
  if ("SpdrId" in spdrOrPdsr) {
    spdrOrPdsrId = spdrOrPdsr?.SpdrId || -1;
  }

  if ("PdsrId" in spdrOrPdsr) {
    spdrOrPdsrId = spdrOrPdsr?.PdsrId || -1;
  }
  return spdrOrPdsrId;
}
